export const environment = {
  name: 'staging',
  production: false,
  SIGN_UP_URL: 'https://discover.risepeople.com/xero-and-rise/',
  JE_API_URL: 'https://je-gateway.rise-staging.com',
  APP_NAME: 'je-utility-fe'
};
